export default __webpack_public_path__ + "static/media/frentes_icon.90a41a8c.svg";